<template>
  <div class="not-defined">
    <img src="@assets/moblie/images/404.png" />

    <div class="content">
      <h3 class="title">頁面未找到</h3>
      <span
        >抱歉！您訪問的頁面不存在，請返回上一級或點擊下方按鈕返回首頁...</span
      >
    </div>

    <div class="btn" @click="$router.replace({ path: '/' })">
      返回首頁
    </div>
  </div>
</template>

<script>
export default {
  name: "NotDefined"
};
</script>

<style scoped>
.not-defined img {
  width: 100%;
  margin-top: 18%;
}

.content {
  padding: 0 1rem;
  text-align: center;
  color: #44405e;
  font-size: 15px;
}

.title {
  margin-bottom: 0.6rem;
  color: #302c48;
  font-size: 20px;
}

.btn {
  color: #fff;
  background-color: #ef4c4c;
  font-size: 16px;
  padding: 0.16rem;
  border-radius: 25px;
  text-align: center;
  width: 2.4rem;
  margin: 0 auto;
  margin-top: 1rem;
}
</style>
